<template>
<ValidationObserver :ref="`rentalLocation${reference}`">
  <div v-if="locationEntry.addressDetails" class="form-group mb-1">
    <div class="form-group row mb-0">
      <div class="col-12">
        <address-details :address-entity="locationEntry.addressDetails" :internal="true" :mandatory="!isReadOnly" :is-read-only="isReadOnly"></address-details>
      </div>
    </div>
  </div>

  <div class="form-group row mb-0">
    <div class="col-3">
      <label class="col-form-label text-left">Location&nbsp;Type<span v-if="!isReadOnly" class="text-danger">*</span></label>
      <ValidationProvider rules="required" :name="`locationEntry${reference}.K_Category`" v-slot="{ errors }">
        <b-form-select class="form-control" v-model="locationEntry.K_Category" :disabled="isReadOnly">
          <option value="Head Office" :disabled="!allowHeadOfficeSelection">Head Office</option>
          <option value="Branch">Branch</option>
        </b-form-select>
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
    <div class="col-3">
      <label class="col-form-label text-left">Location Code (alphanumeric & hyphens only)</label>
      <ValidationProvider :rules="{ max: 30, regex: this.BRANCH_CODE_REGEX }" :name="`locationEntry${reference}.K_BranchCode`" v-slot="{ errors }">
        <b-form-input class="form-control text-uppercase" v-model="locationEntry.K_BranchCode" :disabled="isReadOnly"
               maxlength="30" @input="formatBranchCode(locationEntry)"/>
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </div>
</ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import AddressDetails from "@/view/pages/wizard/components/AddressDetails.vue";

export default {
  name: "BusinessLocation",

  components: {
    AddressDetails
  },

  props: {
    locationEntry: Object,
    reference: String,
    isReadOnly: Boolean,
    allowHeadOfficeSelection: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      postalAddressOptions: [
        { text: "Yes", value: "samePostalAddress" },
        { text: "No", value: "differentPostalAddress" },
      ],
    };
  },

  methods : {
    formatBranchCode: function(location) {
      if(location.K_BranchCode) {
        location.K_BranchCode = location.K_BranchCode.toUpperCase().replace(/[^0-9a-zA-Z_-]/gi, '').trim();
      }
    }
  },

  computed: {
    BRANCH_CODE_REGEX: function () {
      return /^[a-zA-Z0-9-_]+$/;
    }
  }
};
</script>
